// The How to Play card before a level begins: shown at most MAX_SHOWINGS
// times per device, or never again once the player ticks "Don't show this
// again" (docs/02-Game-Design/Tutorial.md).
export const HOW_TO_PLAY_KEY = 'wits.howToPlay';
export const MAX_SHOWINGS = 3;

interface Seen {
  shown: number;
  optedOut: boolean;
}

function read(): Seen {
  try {
    const raw = localStorage.getItem(HOW_TO_PLAY_KEY);
    if (!raw) return { shown: 0, optedOut: false };
    const parsed = JSON.parse(raw) as Partial<Seen>;
    return { shown: Number(parsed.shown) || 0, optedOut: parsed.optedOut === true };
  } catch {
    return { shown: 0, optedOut: false };
  }
}

function write(seen: Seen): void {
  try {
    localStorage.setItem(HOW_TO_PLAY_KEY, JSON.stringify(seen));
  } catch {
    // Private mode or blocked storage: the card shows again next time.
  }
}

/** Whether the card shows before this level. */
export function howToPlayDue(): boolean {
  const r = read();
  return !r.optedOut && r.shown < MAX_SHOWINGS;
}

/** The card has been shown once more. */
export function noteHowToPlayShown(): void {
  const r = read();
  write({ ...r, shown: r.shown + 1 });
}

/** The player ticked "Don't show this again". */
export function optOutOfHowToPlay(): void {
  write({ ...read(), optedOut: true });
}
